module.exports = __webpack_public_path__ + "img/icon-attention.d4c23fdd.svg";